import Box from '@mui/material/Box';

import * as constants from '@/constants';

const Footer = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        width: '100%',
        backgroundColor: '#e4e4e4',
        color: '#777',
        textAlign: 'right',
        fontSize: '0.8em',
        padding: "2px 10px",
        boxShadow: "0px -1px 2px #ddd"
      }}
    >
      {constants.COPYRIGHT}
    </Box>
  );
};

export default Footer;
